import { render, staticRenderFns } from "./investModel1920.vue?vue&type=template&id=5e07852a&scoped=true&"
import script from "./investModel1920.vue?vue&type=script&lang=js&"
export * from "./investModel1920.vue?vue&type=script&lang=js&"
import style0 from "./investModel1920.vue?vue&type=style&index=0&id=5e07852a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e07852a",
  null
  
)

export default component.exports